import { DataGrid } from '@mui/x-data-grid';

const ErrorList = ({ errorActions, getWellName }) => {
  return (
    <div style={{ height: 400, width: 270 }}>
      <DataGrid
        rowHeight={40}
        rows={errorActions
          .getErrorWells()
          .map((well) => ({
            id: getWellName(well),
            error: errorActions.getError(well),
          }))}
        columns={[
          { field: 'id', headerName: 'Well', width: 70 },
          { field: 'error', headerName: 'Errors', width: 200 },
        ]}
        pageSize={10}
        rowsPerPageOptions={[10]}
      />
    </div>
  );
};

export default ErrorList;
